import { styled } from '@acko-tech/building-blocks.ui.common';

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    align-self: center;
    max-width: 300px;
    margin: auto;
`;

export const CongratulationImage = styled.div`
    display: flex;
    justify-content: center;
`;

export const Text = styled.div`
    display: flex;
    justify-content: center;
    font-weight: 600;
    font-size: 18px;
    line-height: 24px;
    color: #040222;
    margin-top: 16px;
`;

export const Description = styled.div`
    display: flex;
    justify-content: center;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    text-align: center;
    color: #5b5675;
    margin-top: 8px;
`;

export const GoHomeButtonWrapper = styled.div`
    display: flex;
    width: 100%;
    margin-top: 32px;
`;
